import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const styles = {
  card: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: "1.5em",
  },
  pos: {
    marginBottom: 12,
  },
};

class NotValidWbsCard extends React.Component 
{
  
  render(){
    const { classes } = this.props;
    return (
      <Card className={classes.card}>
        <CardContent>
          <Typography className={classes.title} color="textSecondary" gutterBottom>
            This is not a valid Project, please make sure the Planning is correct
          </Typography>
        </CardContent>
      </Card>
    );
  }
}

NotValidWbsCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NotValidWbsCard);


// WEBPACK FOOTER //
// ./src/features/wbs/NotValidWbsCard.js